{
  "app.name": "Cargofollow",
  "nav.dashboard.label": "Overview",
  "nav.shipments.label": "Shipments",
  "nav.api_keys.label": "API keys",
  "nav.webhooks.label": "Webhooks",
  "nav.events.label": "Events",
  "nav.logs.label": "Logs",
  "nav.settings.label": "Settings",
  "nav.conformance.label": "Conformance",
  "nav.billing.label": "Billing",
  "nav.label": "Console navigation",
  "language.label": "Language",
  "language.nl": "Dutch",
  "language.en": "English",
  "language.de": "German",
  "loading": "Loading…",
  "button.retry": "Try again",
  "button.sign_out": "Sign out",
  "error.title": "Something went wrong",
  "error.body": "Try again. If it keeps failing, get in touch with us.",
  "error.not_found.title": "Page not found",
  "error.not_found.body": "This page does not exist (any more).",
  "error.network": "No connection to the API.",
  "error.unexpected": "Unexpected error.",
  "login.title": "Sign in",
  "login.intro": "Enter your e-mail address. You will get a link that signs you straight in.",
  "login.email.label": "E-mail address",
  "login.submit": "Send the sign-in link",
  "login.sent.title": "Check your mail",
  "login.sent.body": "We sent a sign-in link to {email}. The link is valid for 15 minutes.",
  "login.to_signup": "No account yet? Create one.",
  "signup.title": "Create an account",
  "signup.intro": "A sandbox key in one minute. No credit card, no sales call.",
  "signup.name.label": "Your name",
  "signup.organization.label": "Company name",
  "signup.email.label": "Work e-mail address",
  "signup.submit": "Create account",
  "signup.sent.title": "One more click",
  "signup.sent.body": "We sent a confirmation link to {email}. Open it to create your organisation.",
  "signup.to_login": "Already have an account? Sign in.",
  "welcome.title": "Welcome to Cargofollow",
  "welcome.intro": "Your organisation {organization} is ready, with a sandbox key.",
  "welcome.key.label": "Your sk_test_ key",
  "welcome.key.once": "This key is shown exactly once. Store it now; after this you can only create a new one.",
  "welcome.key.copy": "Copy key",
  "welcome.key.copied": "Copied",
  "welcome.key.gone.title": "The key has already been shown",
  "welcome.key.gone.body": "For security reasons a key is shown only once. Create a new key under API keys.",
  "welcome.quickstart.title": "Try it right away",
  "welcome.quickstart.body": "Create your first shipment with this curl:",
  "welcome.continue": "Go to the overview",
  "live.title": "Going live",
  "live.body": "Cargofollow enables sk_live_ keys by hand, after you have completed the conformance checklist. Until then you work with sk_test_ in the sandbox.",
  "live.request": "Request live access",
  "dashboard.title": "Overview",
  "dashboard.intro": "Your shipments, keys, webhooks and logs will appear here.",
  "email.magic_link.subject": "Your sign-in link for Cargofollow",
  "email.magic_link.body": "Click this link to sign in to the Cargofollow console: {url}",
  "email.magic_link.ignore": "Did you not request this? Then you can ignore this message.",
  "login.error.unknown_email": "There is no account for this address, or your invitation expired. Create an account.",
  "settings.title": "Settings",
  "settings.nav.members": "Members",
  "members.title": "Members",
  "members.intro": "Who may do what in this organisation. A role only decides what you see and may press in the console; what an API key may do is in the scopes of that key.",
  "members.column.member": "Member",
  "members.column.role": "Role",
  "members.column.actions": "Actions",
  "members.you": "you",
  "members.empty": "There are no other members yet.",
  "members.role.label": "Role of {name}",
  "members.role.owner": "Owner",
  "members.role.admin": "Admin",
  "members.role.developer": "Developer",
  "members.role.viewer": "Viewer",
  "members.role.owner.hint": "Everything, including deleting the organisation and handing over ownership.",
  "members.role.admin.hint": "Everything except deleting the organisation and changing owners.",
  "members.role.developer.hint": "Read and write keys, webhooks and shipments; no members.",
  "members.role.viewer.hint": "Read only.",
  "members.remove": "Remove",
  "members.remove.confirm": "Remove {name} from this organisation?",
  "members.last_owner": "The last owner cannot be removed or demoted.",
  "members.forbidden.title": "No access to members",
  "members.forbidden.body": "Your role may not view the member list. Ask an admin for access.",
  "invite.title": "Invite a colleague",
  "invite.email.label": "E-mail address",
  "invite.role.label": "Role",
  "invite.submit": "Send invitation",
  "invite.sent": "Invitation sent to {email}.",
  "invitations.title": "Pending invitations",
  "invitations.empty": "No pending invitations.",
  "invitations.expires": "Expires {expires}",
  "invitations.revoke": "Revoke",
  "accept.title": "You have been invited",
  "accept.intro": "{organization} invites you as {role}. We send a sign-in link to {email}; it makes you a member right away.",
  "accept.submit": "Accept and sign in",
  "accept.sent.title": "Check your mail",
  "accept.sent.body": "We sent a sign-in link to {email}. Open it to join.",
  "accept.invalid.title": "This invitation is no longer valid",
  "accept.invalid.body": "The invitation was revoked, expired or already used. Ask your colleague for a new one.",
  "api_keys.new": "New key",
  "api_keys.new.hint": "Create a new key. You see the secret itself exactly once.",
  "button.cancel": "Cancel",
  "button.copy": "Copy",
  "button.copied": "Copied",
  "mode.label": "Mode",
  "mode.test": "Test",
  "mode.live": "Live",
  "mode.live.disabled": "Live is not enabled for this organisation yet.",
  "api_keys.intro": "Keys authenticate your API calls. A key belongs to one mode: sk_test_ touches the sandbox, sk_live_ the real world.",
  "api_keys.column.name": "Name",
  "api_keys.column.prefix": "Key",
  "api_keys.column.scopes": "Scopes",
  "api_keys.column.created_by": "Created by",
  "api_keys.column.last_used": "Last used",
  "api_keys.column.actions": "Actions",
  "api_keys.status.revoked": "Revoked",
  "api_keys.never_used": "Not used yet",
  "api_keys.unknown_creator": "At signup",
  "api_keys.empty": "There are no keys in this mode yet.",
  "api_keys.revoke": "Revoke",
  "api_keys.revoke.confirm": "Revoke key {name}? Calls with this key fail immediately.",
  "api_keys.form.title": "New key",
  "api_keys.form.name": "Name",
  "api_keys.form.name.hint": "What do you use it for? For example: backend production.",
  "api_keys.form.mode": "Mode",
  "api_keys.form.scopes": "Scopes",
  "api_keys.form.submit": "Create key",
  "api_keys.created.title": "Your new key",
  "api_keys.created.once": "This key is shown exactly once. Store it now; afterwards you only see the prefix.",
  "api_keys.created.done": "I stored it",
  "api_keys.live.blocked": "Cargofollow enables live keys by hand, after the conformance checklist. Request live access and we will get in touch.",
  "live.request.sent": "Your request has been sent. We will get in touch at {email}.",
  "live.request.note": "Note (optional)",
  "conformance.intro": "Before you go live we want to see that your integration handles what goes wrong in production too. The checklist derives these twelve scenarios from your own events, logs and webhook deliveries in test mode.",
  "conformance.progress": "{passed} of {total} scenarios demonstrated",
  "conformance.checked": "Last checked on {moment}",
  "conformance.never_checked": "Not checked yet",
  "conformance.recheck": "Check now",
  "conformance.ready.title": "Ready for live",
  "conformance.ready.body": "Every scenario is demonstrated. Request live access; Cargofollow turns sk_live_ keys on by hand.",
  "conformance.blocked": "Requesting live access opens once all twelve scenarios are demonstrated.",
  "conformance.blocked.title": "Not ready for live yet",
  "conformance.requested": "Live access requested on {moment}.",
  "conformance.enabled.title": "Your organisation is already live",
  "conformance.enabled.body": "sk_live_ keys are on. The checklist stays as a record of what you demonstrated in the sandbox.",
  "conformance.table.caption": "Conformance scenarios",
  "conformance.column.status": "Status",
  "conformance.column.scenario": "Scenario",
  "conformance.column.moment": "Demonstrated",
  "conformance.status.passed": "Demonstrated",
  "conformance.status.pending": "Not demonstrated yet",
  "conformance.status.failed": "Failed",
  "conformance.hint": "How do I demonstrate this?",
  "conformance.scenario.create_shipment.title": "Create a shipment",
  "conformance.scenario.create_shipment.body": "You created a shipment with POST /v1/shipments.",
  "conformance.scenario.validate_with_error_handled.title": "Handle an error",
  "conformance.scenario.validate_with_error_handled.body": "You received a 422 on an invalid body and created a shipment after it.",
  "conformance.scenario.issue.title": "Issue",
  "conformance.scenario.issue.body": "You issued a shipment, which recorded version 1 of the consignment note.",
  "conformance.scenario.signature_via_link.title": "Sign through a link",
  "conformance.scenario.signature_via_link.body": "Someone signed through a signing link, without an API key.",
  "conformance.scenario.delivery_with_pod.title": "Deliver with an ePOD",
  "conformance.scenario.delivery_with_pod.body": "You delivered a shipment and read its proof of delivery back.",
  "conformance.scenario.webhook_endpoint_configured.title": "Webhook endpoint configured",
  "conformance.scenario.webhook_endpoint_configured.body": "You registered an endpoint for events to go to.",
  "conformance.scenario.webhook_echo_verified.title": "Echo header confirmed",
  "conformance.scenario.webhook_echo_verified.body": "Your receiver answered a ping with the same freightapi-echo header we sent it.",
  "conformance.scenario.webhook_delivery_succeeded.title": "Delivery succeeded",
  "conformance.scenario.webhook_delivery_succeeded.body": "Your receiver accepted a real event with a 2xx.",
  "conformance.scenario.idempotency_key_used.title": "Idempotency-Key used",
  "conformance.scenario.idempotency_key_used.body": "You sent a POST with an Idempotency-Key, so a repeated call does not create a second shipment.",
  "conformance.scenario.integrity_checked.title": "Hash chain verified",
  "conformance.scenario.integrity_checked.body": "You fetched the integrity report of a shipment.",
  "conformance.scenario.pdf_downloaded.title": "PDF downloaded",
  "conformance.scenario.pdf_downloaded.body": "You fetched the consignment note as a PDF.",
  "conformance.scenario.auto_sandbox_run.title": "Sandbox run with auto",
  "conformance.scenario.auto_sandbox_run.body": "You let a sandbox shipment run its whole lifecycle with action: auto.",
  "webhooks.intro": "Webhook endpoints receive events from Cargofollow. Every delivery is signed with the endpoint's secret.",
  "webhooks.column.url": "URL",
  "webhooks.column.events": "Events",
  "webhooks.column.status": "Status",
  "webhooks.column.actions": "Actions",
  "webhooks.status.active": "Active",
  "webhooks.status.inactive": "Inactive",
  "webhooks.empty": "There are no endpoints in this mode yet.",
  "webhooks.new": "New endpoint",
  "webhooks.form.title": "New endpoint",
  "webhooks.form.url": "URL",
  "webhooks.form.events": "Events",
  "webhooks.form.events.hint": "Comma-separated: shipment.*, signature.completed, or * for everything.",
  "webhooks.form.description": "Description",
  "webhooks.form.submit": "Create endpoint",
  "webhooks.secret.title": "The secret of this endpoint",
  "webhooks.secret.once": "This secret is shown exactly once. Store it; you verify the signature of every delivery with it.",
  "webhooks.test": "Send test",
  "webhooks.test.result": "HTTP {status} in {duration} ms",
  "webhooks.test.failed": "Failed after {duration} ms: {error}",
  "webhooks.pause": "Pause",
  "webhooks.activate": "Activate",
  "webhooks.delete": "Delete",
  "webhooks.delete.confirm": "Delete endpoint {url}? Deliveries stop immediately.",
  "settings.nav.organization": "Organisation",
  "organization.title": "Organisation",
  "organization.intro": "The name on documents, the provider that executes a shipment and how long we keep data.",
  "organization.name.label": "Name",
  "organization.default_provider.label": "Default provider",
  "organization.default_provider.hint": "The provider a shipment gets when the call names none.",
  "organization.providers.label": "Allowed providers",
  "organization.providers.hint": "Only these providers can be picked for a shipment.",
  "organization.retention.label": "Retention (days)",
  "organization.retention.hint": "Between 30 and 3650 days.",
  "organization.save": "Save",
  "organization.saved": "Settings saved.",
  "shipments.intro": "Every shipment in this mode, newest first.",
  "shipments.filter.status": "Status",
  "shipments.filter.status.any": "All statuses",
  "shipments.filter.reference": "Reference",
  "shipments.filter.provider": "Provider",
  "shipments.filter.provider.any": "All providers",
  "shipments.filter.created_after": "Created from",
  "shipments.filter.created_before": "Created up to and including",
  "shipments.filter.apply": "Filter",
  "shipments.filter.reset": "Clear",
  "shipments.column.reference": "Reference",
  "shipments.column.status": "Status",
  "shipments.column.route": "Route",
  "shipments.column.provider": "Provider",
  "shipments.column.created": "Created",
  "shipments.version": "Version {version}",
  "shipments.empty.title": "No shipments",
  "shipments.empty.body": "No shipment matches these filters. Create one with the API, or adjust the filters.",
  "shipments.page.previous": "Previous",
  "shipments.page.next": "Next",
  "shipments.detail.back": "Back to shipments",
  "shipments.detail.created": "Created on {timestamp}",
  "shipments.tabs.label": "Tabs of this shipment",
  "shipments.tab.overview": "Overview",
  "shipments.tab.timeline": "Timeline",
  "shipments.tab.documents": "Documents",
  "shipments.tab.signatures": "Signatures",
  "shipments.tab.pod": "POD",
  "shipments.tab.provider": "Provider",
  "shipments.tab.webhooks": "Webhooks",
  "shipments.tab.raw": "Raw JSON",
  "shipments.tab.authorisations": "Authorisations",
  "shipments.authorisations.title": "Authorisation register",
  "shipments.authorisations.intro": "Who may perform which operation on this eFTI data set, for how long and over which part of the data (Article 5 of Implementing Regulation (EU) 2025/2243). Withdrawn rights stay: the register has to remain auditable for as long as the data set itself.",
  "shipments.authorisations.dataset": "Data set UUID: {uuid}",
  "shipments.authorisations.dataset.none": "No eFTI data set yet; these rights apply the moment there is one.",
  "shipments.authorisations.column.party": "Party",
  "shipments.authorisations.column.role": "Role",
  "shipments.authorisations.column.operations": "Operations",
  "shipments.authorisations.column.window": "Valid",
  "shipments.authorisations.column.status": "Status",
  "shipments.authorisations.column.actions": "Actions",
  "shipments.authorisations.scope.all": "Whole common data set",
  "shipments.authorisations.until.none": "open-ended",
  "shipments.authorisations.baseline": "Cannot be withdrawn",
  "shipments.authorisations.revoke": "Withdraw",
  "shipments.authorisations.revoke.confirm": "Withdraw this right? The entry stays in the register, with the moment it was withdrawn.",
  "shipments.authorisations.revoke.done": "Right withdrawn.",
  "shipments.authorisations.empty.title": "No register",
  "shipments.authorisations.empty.body": "This shipment has no authorisation register. Does it exist in this mode?",
  "shipments.authorisations.grant.title": "Grant a right",
  "shipments.authorisations.grant.intro": "The operations follow from the role. A party without a Cargofollow account is named by an e-mail address and always gets an end date.",
  "shipments.authorisations.grant.party_type": "Kind of party",
  "shipments.authorisations.grant.party_ref": "Id of the party",
  "shipments.authorisations.grant.email": "E-mail address",
  "shipments.authorisations.grant.role": "Role",
  "shipments.authorisations.grant.valid_until": "Valid until",
  "shipments.authorisations.grant.valid_until.hint": "Required for a party without an account, and at most 90 days.",
  "shipments.authorisations.grant.submit": "Grant",
  "shipments.authorisations.grant.done": "Right granted.",
  "shipments.authorisations.party_type.organization": "Organisation",
  "shipments.authorisations.party_type.member": "User",
  "shipments.authorisations.party_type.api_key": "API key",
  "shipments.authorisations.party_type.contact": "Contact without an account",
  "shipments.authorisations.party_type.authority": "Authority",
  "shipments.authorisations.role.data_holder": "Data holder",
  "shipments.authorisations.role.consignor": "Consignor",
  "shipments.authorisations.role.carrier": "Carrier",
  "shipments.authorisations.role.consignee": "Consignee",
  "shipments.authorisations.role.authority": "Authority",
  "shipments.authorisations.role.other": "Other",
  "shipments.authorisations.status.active": "Active",
  "shipments.authorisations.status.scheduled": "Scheduled",
  "shipments.authorisations.status.expired": "Expired",
  "shipments.authorisations.status.revoked": "Withdrawn",
  "shipments.authorisations.source.baseline": "Data holder",
  "shipments.authorisations.source.granted": "Granted",
  "shipments.authorisations.source.derived": "Automatic",
  "shipments.processing.title": "Processing log",
  "shipments.processing.intro": "Every operation on this data set, newest first, as Article 9(5) asks for it. Refusals are in here too, and so is access by an authority through a national eFTI gate.",
  "shipments.processing.empty": "No operations recorded yet.",
  "shipments.processing.column.moment": "Moment",
  "shipments.processing.column.operation": "Operation",
  "shipments.processing.column.party": "Party",
  "shipments.processing.column.outcome": "Outcome",
  "shipments.processing.outcome.allowed": "Allowed",
  "shipments.processing.outcome.refused": "Refused",
  "shipments.processing.operation.create": "Create",
  "shipments.processing.operation.edit": "Edit",
  "shipments.processing.operation.read": "Read",
  "shipments.processing.operation.download": "Download",
  "shipments.processing.operation.consignor_signature": "Consignor signature",
  "shipments.processing.operation.carrier_signature": "Carrier signature",
  "shipments.processing.operation.consignee_signature": "Consignee signature",
  "shipments.processing.operation.combined_transport_stamp": "Combined transport stamp",
  "shipments.processing.operation.archive": "Archive",
  "shipments.processing.operation.waste_documents_download": "Download waste documents",
  "shipments.processing.operation.waste_carrier_confirmation": "Waste carrier confirmation",
  "shipments.not_found.title": "Shipment not found",
  "shipments.not_found.body": "This shipment does not exist in this organisation and mode. Could it be in the other mode?",
  "shipments.more": "Load more",
  "shipments.integrity.ok": "Chain intact",
  "shipments.integrity.ok.detail": "{events} events, unbroken since it was created.",
  "shipments.integrity.broken": "Chain broken",
  "shipments.integrity.broken.detail": "The chain stops adding up at seq {seq}.",
  "shipments.integrity.gaps": "Missing sequence numbers: {gaps}",
  "shipments.integrity.head": "Head hash",
  "shipments.integrity.verified_at": "Verified on {timestamp}",
  "shipments.events.title": "Events and hashes",
  "shipments.events.column.seq": "Seq",
  "shipments.events.column.event": "Event",
  "shipments.events.column.occurred": "Moment",
  "shipments.events.column.actor": "Actor",
  "shipments.events.column.hash": "Hash",
  "shipments.events.column.prev_hash": "Previous hash",
  "shipments.trace.title": "API calls",
  "shipments.trace.intro": "The calls that named this shipment, newest first.",
  "shipments.trace.empty": "No calls within the retention window of the logs.",
  "shipments.trace.column.call": "Call",
  "shipments.trace.column.status": "Status",
  "shipments.trace.column.duration": "Duration",
  "shipments.trace.column.request_id": "Request id",
  "shipments.trace.column.moment": "Moment",
  "shipments.signatures.empty": "Nobody has signed yet.",
  "shipments.signatures.column.role": "Role",
  "shipments.signatures.column.signer": "Signer",
  "shipments.signatures.column.method": "Method",
  "shipments.signatures.column.signed_at": "Signed at",
  "shipments.signatures.column.hash": "Version hash",
  "shipments.pod.empty.title": "No proof of delivery yet",
  "shipments.pod.empty.body": "The proof of delivery appears once the consignee has signed at delivery.",
  "shipments.pod.delivered_at": "Delivered at",
  "shipments.pod.signed_by": "Signed by",
  "shipments.pod.colli": "Packages",
  "shipments.pod.remarks": "Remarks",
  "shipments.pod.remarks.empty": "No remarks at delivery.",
  "shipments.pod.photos": "Photos",
  "shipments.pod.pdf": "Proof of delivery (PDF)",
  "shipments.pod.pdf.none": "There is no PDF yet.",
  "shipments.provider.empty.title": "No provider link yet",
  "shipments.provider.empty.body": "A shipment gets a link once it has been issued and the synchronisation has run.",
  "shipments.provider.provider": "Provider",
  "shipments.provider.status": "Sync status",
  "shipments.provider.external_id": "External id",
  "shipments.provider.last_operation": "Last operation",
  "shipments.provider.last_synced": "Last synchronised",
  "shipments.provider.error": "Last error",
  "shipments.provider.retry": "Synchronise again",
  "shipments.provider.retry.started": "The synchronisation was started again. Refresh in a few seconds.",
  "shipments.provider.status.pending": "Pending",
  "shipments.provider.status.synced": "Synchronised",
  "shipments.provider.status.failed": "Failed",
  "shipments.provider.status.cancelled": "Cancelled",
  "shipments.provider.trace.title": "Trace",
  "shipments.provider.trace.empty": "The synchronisation has not recorded a step yet.",
  "shipments.provider.trace.column.step": "Step",
  "shipments.provider.trace.column.outcome": "Outcome",
  "shipments.provider.trace.column.detail": "Detail",
  "shipments.provider.trace.column.moment": "Moment",
  "shipments.provider.step.normalize": "Normalise",
  "shipments.provider.step.validate": "Validate",
  "shipments.provider.step.select": "Select provider",
  "shipments.provider.step.publish": "Publish",
  "shipments.provider.step.status": "Read status",
  "shipments.provider.outcome.ok": "Succeeded",
  "shipments.provider.outcome.skipped": "Skipped",
  "shipments.provider.outcome.failed": "Failed",
  "shipments.webhooks.empty": "There are no deliveries for this shipment yet.",
  "shipments.webhooks.column.event": "Event",
  "shipments.webhooks.column.status": "Status",
  "shipments.webhooks.column.attempt": "Attempt",
  "shipments.webhooks.column.response": "Response",
  "shipments.webhooks.column.moment": "Moment",
  "shipments.webhooks.status.pending": "Queued",
  "shipments.webhooks.status.succeeded": "Succeeded",
  "shipments.webhooks.status.failed": "Failed",
  "shipments.webhooks.status.dead": "Given up",
  "shipments.raw.intro": "The current version of this shipment, exactly as the API returns it.",
  "shipments.raw.copy": "Copy JSON",
  "shipments.raw.copied": "Copied",
  "button.close": "Close",
  "filter.apply": "Filter",
  "filter.reset": "Clear",
  "page.previous": "Previous",
  "page.next": "Next",
  "webhooks.nav.endpoints": "Endpoints",
  "webhooks.nav.deliveries": "Deliveries",
  "deliveries.intro": "What Cargofollow sent to your endpoints, newest first. Open an event for the exact payload, the response and the timeline of attempts.",
  "deliveries.table.caption": "Webhook deliveries",
  "deliveries.empty.title": "No deliveries yet",
  "deliveries.empty.body": "Once an endpoint is subscribed to an event, every send shows up here.",
  "deliveries.column.event": "Event",
  "deliveries.column.endpoint": "Endpoint",
  "deliveries.column.status": "Status",
  "deliveries.column.attempts": "Attempts",
  "deliveries.column.response": "Last response",
  "deliveries.column.moment": "Moment",
  "deliveries.status.pending": "Queued",
  "deliveries.status.succeeded": "Succeeded",
  "deliveries.status.failed": "Failed",
  "deliveries.status.dead": "Given up",
  "deliveries.attempts": "{attempt} of {max}",
  "deliveries.no_response": "No response",
  "deliveries.filter.status": "Status",
  "deliveries.filter.status.any": "All statuses",
  "deliveries.filter.endpoint": "Endpoint",
  "deliveries.filter.endpoint.any": "All endpoints",
  "deliveries.filter.event": "Event",
  "deliveries.filter.event.any": "All events",
  "deliveries.detail.title": "Delivery",
  "deliveries.detail.event_id": "Event id",
  "deliveries.detail.timeline": "Timeline of attempts",
  "deliveries.detail.attempt": "Send {number} · {status}",
  "deliveries.detail.answered": "Answered {status} in {duration} ms",
  "deliveries.detail.request_headers": "Request headers",
  "deliveries.detail.request_body": "Payload sent",
  "deliveries.detail.response_body": "Response from the receiver",
  "deliveries.detail.none": "Nothing recorded.",
  "deliveries.replay": "Send again",
  "events.intro": "Every event of every shipment in this organisation, newest first. The same rows an integration polls through GET /v1/events.",
  "events.table.caption": "Events",
  "events.empty.title": "No events yet",
  "events.empty.body": "As soon as a shipment is created, its first event appears here.",
  "events.column.type": "Event",
  "events.column.shipment": "Shipment",
  "events.column.actor": "By",
  "events.column.seq": "Seq.",
  "events.column.moment": "Moment",
  "events.filter.type": "Type",
  "events.filter.type.any": "All types",
  "logs.intro": "Every API call of this organisation, with status, duration and the error code of a failure. Never a body: the log keeps no payloads.",
  "logs.table.caption": "API calls",
  "logs.empty.title": "No calls found",
  "logs.empty.body": "No call within the retention window of the log matches this filter.",
  "logs.column.call": "Call",
  "logs.column.status": "Status",
  "logs.column.duration": "Duration",
  "logs.column.error": "Error code",
  "logs.column.moment": "Moment",
  "logs.duration": "{ms} ms",
  "logs.filter.status": "Status",
  "logs.filter.path": "Path",
  "logs.filter.path.hint": "Exact path, without the query string.",
  "logs.filter.request_id": "Request id",
  "logs.detail.title": "API call",
  "logs.detail.request_id": "Request id",
  "logs.detail.no_body": "The log keeps summaries, not request or response bodies.",
  "logs.error.docs": "What does this code mean?",
  "billing.intro": "What this organisation used, which plan it is on, and the invoices the billing provider has for it. Test mode is counted and shown, but never charged.",
  "billing.plan.title": "Subscription",
  "billing.plan.tier": "Tier",
  "billing.plan.status": "Status",
  "billing.plan.period_end": "Current period ends",
  "billing.plan.period_end.none": "No period known yet",
  "billing.tier.sandbox": "Sandbox",
  "billing.tier.starter": "Starter",
  "billing.tier.scale": "Scale",
  "billing.tier.enterprise": "Enterprise",
  "billing.status.active": "Paid",
  "billing.status.past_due": "Payment failed",
  "billing.status.canceled": "Cancelled",
  "billing.unconfigured.title": "Billing is switched off in this environment",
  "billing.unconfigured.body": "No billing provider is connected, so nothing is charged and the customer portal is unavailable. The usage below is still being counted.",
  "billing.usage.title": "Usage",
  "billing.usage.window": "{from} up to and including {to}",
  "billing.usage.test_mode": "You are looking at test mode. The sandbox is free without a time limit; these numbers never reach an invoice.",
  "billing.usage.table.caption": "Usage per day",
  "billing.usage.empty.title": "Nothing counted yet",
  "billing.usage.empty.body": "The nightly aggregation has recorded nothing for this period. The first day appears here as soon as a shipment is issued or a signature is recorded.",
  "billing.column.day": "Day",
  "billing.column.shipments_issued": "Issued",
  "billing.column.signatures": "Signatures",
  "billing.column.notifications": "Notifications",
  "billing.column.documents": "Documents",
  "billing.column.storage": "Storage",
  "billing.totals.title": "Total for this period",
  "billing.totals.storage.hint": "Storage is the level on the last day, not a sum.",
  "billing.invoices.title": "Invoices",
  "billing.invoices.table.caption": "Invoices",
  "billing.invoices.column.number": "Number",
  "billing.invoices.column.status": "Status",
  "billing.invoices.column.amount": "Amount",
  "billing.invoices.column.period": "Period until",
  "billing.invoices.column.link": "Document",
  "billing.invoices.status.draft": "Draft",
  "billing.invoices.status.open": "Open",
  "billing.invoices.status.paid": "Paid",
  "billing.invoices.status.uncollectible": "Uncollectible",
  "billing.invoices.status.void": "Void",
  "billing.invoices.empty.title": "No invoices yet",
  "billing.invoices.empty.body": "As soon as the first billing period closes, the invoice appears here and in the customer portal.",
  "billing.invoices.open": "View",
  "billing.portal.title": "Customer portal",
  "billing.portal.body": "Changing payment details, downloading invoices and reviewing the subscription all happen at the billing provider.",
  "billing.portal.button": "Open the customer portal",
  "billing.portal.unavailable": "Unavailable while no billing provider is connected.",
  "billing.portal.failed": "The customer portal could not be opened. Please try again later.",
  "settings.nav.security": "Security",
  "security.title": "Two-factor authentication",
  "security.intro": "An authenticator app next to the sign-in link. Business users of an eFTI platform are required to have a second factor (IR (EU) 2025/2243).",
  "security.enabled": "Two-factor authentication is on for your account.",
  "security.disabled": "Your account has no authenticator yet. Without a second factor the link in your mailbox is the only key.",
  "security.enable": "Set up an authenticator",
  "security.disable": "Turn off",
  "security.regenerate": "New recovery codes",
  "security.recovery_remaining": "{count} recovery codes left.",
  "security.locked": "This organisation requires two-factor authentication; an owner or admin has to lift that requirement first.",
  "security.policy.title": "For the whole organisation",
  "security.policy.intro": "Anyone without an authenticator lands on the setup screen on their next request, not in front of a closed door.",
  "security.policy.label": "Require two-factor authentication of every member",
  "security.policy.hint": "Turning it off again leaves existing authenticators in place.",
  "two_factor.setup.title": "Scan the QR code",
  "two_factor.setup.intro": "Open your authenticator app — 1Password, Bitwarden, Google Authenticator, Aegis — and scan this code. Then type the six digits it shows.",
  "two_factor.setup.manual": "Phone cannot scan? Enter this key by hand instead.",
  "two_factor.setup.qr.label": "QR code for your authenticator app",
  "two_factor.setup.submit": "Finish setup",
  "two_factor.code.label": "Code from the app",
  "two_factor.code.hint": "Six digits, valid for thirty seconds.",
  "two_factor.recovery.title": "Keep your recovery codes",
  "two_factor.recovery.intro": "Each code works once and replaces the app if you lose your phone. We show them now, once, and never again.",
  "two_factor.recovery.download": "Download",
  "two_factor.recovery.acknowledge": "I have saved them",
  "two_factor.recovery.label": "Recovery code",
  "two_factor.recovery.hint": "One of the codes you saved during setup.",
  "two_factor.prompt.title": "Confirm it is you",
  "two_factor.prompt.body": "Type the six digits your authenticator app is showing now.",
  "two_factor.prompt.recovery_body": "Type one of your recovery codes. Each code works exactly once.",
  "two_factor.prompt.submit": "Continue",
  "two_factor.prompt.use_recovery": "Phone not to hand? Use a recovery code",
  "two_factor.prompt.use_totp": "Use the code from the app after all",
  "two_factor.prompt.lost": "Lost both? An owner or admin of your organisation can reset your second factor.",
  "two_factor.required.title": "Set up two-factor authentication",
  "two_factor.required.body": "This organisation requires a second factor. Until you have an authenticator, the rest of the console stays closed.",
  "two_factor.done.title": "All set",
  "two_factor.done.body": "This session has already been confirmed.",
  "two_factor.done.continue": "Go to the console",
  "two_factor.error.invalid": "That code is wrong, expired or already used.",
  "two_factor.error.required": "This page asks for your second factor first.",
  "two_factor.error.too_many": "Too many attempts. Try again in a few minutes.",
  "members.reset_two_factor": "Reset 2FA",
  "members.reset_two_factor.confirm": "Clear two-factor authentication for {name}? They will have to set up a new authenticator themselves."
}
